import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { WizardExportConfig } from './models/config.model';

@Injectable({
  providedIn: 'root',
})
export class WizardExportService {
  private wizardConfigSubject = new Subject<WizardExportConfig>();

  constructor() {}

  public loadWizard(config: WizardExportConfig): void {
    this.wizardConfigSubject.next(config);
  }

  public onLoadWizard(): Observable<WizardExportConfig> {
    return this.wizardConfigSubject.asObservable();
  }
}
